import { render } from "./BenefitAccordion.vue?vue&type=template&id=37240174&scoped=true"
import script from "./BenefitAccordion.vue?vue&type=script&lang=js"
export * from "./BenefitAccordion.vue?vue&type=script&lang=js"

import "./BenefitAccordion.vue?vue&type=style&index=0&id=37240174&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37240174"]])

export default __exports__